export default [
  {
    path: '/classes',
    name: 'all_classes',
    component: () =>
      import(
        /* webpackChunkName: 'classes' */
        '@/views/classes/ClassesView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
  {
    path: '/classes/:type/:id',
    name: 'all_classes.class_detail',
    component: () =>
      import(
        /* webpackChunkName: 'class-detail' */
        '@/views/classes/ClassDetailView'
      ),
    meta: { isTimeZoneSensitive: true },
  },
];
